<template>
  <div class="tw-max-w-3xl tw-mb-1.5 md:tw-m-auto">
    <div class="tw-flex tw-items-center tw-px-2 tw-pb-4">
      <div
        id="Location"
        @click="goToLocationStep"
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw--mr-0.5 tw-text-green-700"
      >
        <div
          class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw--mr-2px tw-py-3 tw-transition tw-duration-500 tw-ease-in-out tw-border-2 tw-border-green-700 tw-rounded-full"
          :class="
            active === 0
              ? 'tw-bg-green-700 tw-text-white tw-cursor-pointer '
              : active === 1
              ? 'tw-cursor-pointer tw-bg-white '
              : 'tw-bg-white'
          "
        >
          <div class="tw-w-5 tw-h-5 tw-flex tw-mx-auto tw-my-0 tw-text-center">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-block tw-mx-auto tw-my-0 tw-text-center"
              viewBox="0 0 20 20"
              fill="#fff"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <label class="tw-text-xs tw-font-medium tw-text-green-700"> Location </label>
      </div>
      <div
        id="connector1"
        :class="active >= 1 ? 'tw-border-green-700' : 'tw-border-gray-300'"
        class="tw-flex-auto tw-transition tw-duration-500 tw-ease-in-out tw-border-t-2 tw-p-7px"
      ></div>
      <div
        id="Details"
        @click="goToDetailsStep"
        class="tw-flex tw-flex-col tw-items-center tw-text-gray-300"
      >
        <div
          class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-py-3 tw-transition tw-duration-500 tw-ease-in-out tw-bg-white tw-border-2 tw-border-gray-300 tw-rounded-full"
          :class="
            active === 1
              ? 'tw-bg-green-700 tw-border-green-700 tw-text-white tw-cursor-pointer '
              : active > 1
              ? 'tw-border-green-700 tw-text-green-700'
              : 'tw-border-gray-300 tw-bg-white'
          "
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            class="tw-w-5 tw-h-6"
            fill="#FFF"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg> -->
          <div class="tw-w-5 tw-h-5 tw-flex tw-mx-auto tw-my-0 tw-text-center">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-block tw-mx-auto tw-my-0 tw-text-center"
              fill="#FFF"
              viewBox="0 0 20 22"
              stroke="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                clip-rule="evenodd"
              />
            </svg> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <label
          class="tw-text-xs tw-font-normal tw-text-center tw-text-black"
          :class="active >= 1 ? 'tw-text-green-700 tw-font-medium' : 'tw-text-black tw-font-normal'"
        >
          Details
        </label>
      </div>
      <div
        id="connector2"
        :class="active >= 2 ? 'tw-border-green-700' : 'tw-border-gray-300'"
        class="tw-flex-auto tw-transition tw-duration-500 tw--mr-1.5 tw-p-7px tw-ease-in-out tw-border-t-2"
      ></div>
      <div
        id="Complete"
        @click="goToCompleteStep"
        class="tw-flex tw-flex-col tw-items-center tw-text-gray-300"
      >
        <div
          class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-py-3 tw-transition tw-duration-500 tw-ease-in-out tw-bg-white tw-border-2 tw-border-gray-300 tw-rounded-full"
          :class="
            active === 2
              ? 'tw-bg-green-700 tw-border-green-700 tw-text-white tw-cursor-pointer'
              : active > 2
              ? active === 3
                ? 'tw-border-green-700 tw-text-green-700 tw-cursor-pointer'
                : 'tw-border-green-700 tw-text-green-700'
              : 'tw-border-gray-300 tw-bg-white'
          "
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 18 18"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg> -->
          <div class="tw-w-5 tw-h-5 tw-flex tw-mx-auto tw-my-0 tw-text-center">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 18 18"
              fill="#FFF"
              stroke="currentColor"
              stroke-width="2"
              class="tw-block tw-mx-auto tw-my-0 tw-text-center"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-block tw-mx-auto tw-my-0 tw-text-center"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <label
          class="tw-text-xs tw-text-center tw-text-black tw-font-normal"
          :class="active >= 2 ? 'tw-text-green-700 tw-font-medium' : 'tw-text-black tw-font-normal'"
        >
          Complete
        </label>
      </div>

      <div
        id="connector3"
        :class="active >= 3 ? 'tw-border-green-700' : 'tw-border-gray-300'"
        class="tw-flex-auto tw-transition tw--ml-1.5 tw-duration-500 tw-p-7px tw-ease-in-out tw-border-t-2"
      ></div>
      <div
        id="Share"
        @click="goToShareStep"
        class="tw-flex tw-flex-col tw-items-center tw-text-gray-300"
      >
        <div
          class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-py-3 tw-transition tw-duration-500 tw-ease-in-out tw-bg-white tw-border-2 tw-border-gray-300 tw-rounded-full"
          :class="
            active === 3
              ? 'tw-bg-green-700 tw-border-green-700 tw-text-white tw-cursor-pointer'
              : 'tw-bg-white'
          "
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            class="tw-w-5 tw-h-6"
            fill="#FFF"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg> -->
          <div class="tw-w-5 tw-h-5 tw-flex tw-mx-auto tw-my-0 tw-text-center">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-block tw-mx-auto tw-my-0 tw-text-center"
              fill="#FFF"
              viewBox="0 0 20 22"
              stroke="currentColor"
            >
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-block tw-mx-auto tw-my-0 tw-text-center"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
          </div>
        </div>
        <label
          class="tw-text-xs tw-font-normal tw-text-black"
          :class="active >= 3 ? 'tw-text-green-700 tw-font-medium' : 'tw-text-black tw-font-normal'"
        >
          Share
        </label>
      </div>
    </div>

    <injury-form v-if="active === 0" :injury="compcase" @next="completeStep" />

    <injury-report-form v-if="active === 1" :injury="compcase" @next="completeStep" />

    <injury-summary
      v-if="active === 2"
      :injury="compcase"
      @next="completeStep"
      @redirectTo="redirectTo"
      @editReport="editInjury"
    />

    <injury-sent-summary
      v-if="active === 3"
      :injury="compcase"
      :memberEmail="memberEmail"
      @redirectTo="redirectTo"
      @reset="reset"
    />
  </div>
</template>
<script>
import InjuryForm from "./InjuryForm.vue";
import InjurySentSummary from "./InjurySentSummary.vue";
import InjuryReportForm from "./InjuryReportForm.vue";
import InjurySummary from "./InjurySummary.vue";

export default {
  components: {
    InjuryForm,
    InjuryReportForm,
    InjurySummary,
    InjurySentSummary,
  },
  data() {
    return {
      active: 0,
      formType: "insert",
      compcase: {
        _id: undefined,
        type: 2,
        scene: undefined,
        sceneOther: undefined,
        status: "Pending",
        isActive: true,
        memberId: undefined,
        meta: {
          competition: {
            _id: undefined,
            name: undefined,
          },
          matchId: undefined,
          teamId: undefined,
          programId: undefined,
          gameDayAdmin: undefined,
        },
        matches: [],
        member: {
          _id: undefined,
          name: "",
        },
        venue: {
          _id: undefined,
          name: "",
          formatted: "",
        },
        dateOfInjuryStr: "",
        timeOfInjuryStr: "",
        dateOfInjury: undefined,
        timeOfInjury: undefined,
        symptons: undefined,
        concussion: {
          clinicalFeatures: undefined,
          lossOfConsciousness: undefined,
          protectiveAction: undefined,
          impact: undefined,
          balanceDisturbance: undefined,
          dazedOrBlank: undefined,
          unusualBehaviour: undefined,
          confusion: undefined,
          memoryImpairment: undefined,
          playerReports: undefined,
        },
        symptomRecord: {
          playerSelfState: "No different",
          headache: { step: 0, stepName: "None" },
          pressureInHead: { step: 0, stepName: "None" },
          neckPain: { step: 0, stepName: "None" },
          nauseaOrVomit: { step: 0, stepName: "None" },
          dizzy: { step: 0, stepName: "None" },
          blurVision: { step: 0, stepName: "None" },
          balanceProblem: { step: 0, stepName: "None" },
          lightSensitivity: { step: 0, stepName: "None" },
          noiseSensitivity: { step: 0, stepName: "None" },
          slowedDown: { step: 0, stepName: "None" },
          inAFog: { step: 0, stepName: "None" },
          notFeelRight: { step: 0, stepName: "None" },
          difficultyInConcentrating: { step: 0, stepName: "None" },
          difficultyRemembering: { step: 0, stepName: "None" },
          fatigued: { step: 0, stepName: "None" },
          confused: { step: 0, stepName: "None" },
          drowsy: { step: 0, stepName: "None" },
          emotional: { step: 0, stepName: "None" },
          irritable: { step: 0, stepName: "None" },
          sad: { step: 0, stepName: "None" },
          nervousOrAnxious: { step: 0, stepName: "None" },
        },
        howPlayerInjured: undefined,
        howPlayerInjuredOther: "",
        treatPlayer: undefined,
        playerReferredTo: undefined,
        playerReferredToOther: "",
        immediateCare: undefined,
        immediateCareOther: "",
        firstResponderName: "",
        firstResponderRole: undefined,
        natureOfInjury: [],
        playerRemoveBy: undefined,
        otherSignificants: "",
        emails: [],
        round: undefined,
      },

      locationStepComplete: false,
      detailsStepComplete: false,
      shareStepComplete: false,
      completeStepComplete: false,
      editReportFlag: false,
      memberEmail: {},
      fromTreatmentPage: false,
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    const { type, id } = this.$route.params;

    this.formType = type || (id ? "update" : "insert");
    if (id) {
      this.$store.commit("root/loading", true);
      try {
        const res = await this.$http.get(`/nrl/api/v1/admin/injury-cases/${id}`);
        let data = res.data.data;
        this.compcase._id = data._id ? data._id : undefined;
        this.compcase.type = data.type;
        this.compcase.scene = data.scene;
        this.compcase.sceneOther = data.sceneOther;
        this.compcase.status = data.status;
        this.compcase.isActive = data.isActive;
        this.compcase.memberId = data.memberId;
        if (data.meta) {
          this.compcase.meta = {
            competition: data.meta.competition,
            matchId: data.meta.matchId,
            teamId: data.meta.teamId,
            programId: data.meta.programId,
            gameDayAdmin: data.meta.gameDayAdmin,
          };
        }

        this.compcase.member = {
          _id: data.member._id,
          name: `${data.member.profile.firstName} ${data.member.profile.lastName}`,
          email: data.member.profile.email,
        };
        this.compcase.venue = {
          _id: data.venue ? data.venue._id : undefined,
          name: data.venue ? data.venue.name : "",
          formatted: data.venue ? data.venue.formatted : "",
        };
        this.compcase.dateOfInjury = data.dateOfInjury
          ? this.dayjs(data.dateOfInjury).valueOf()
          : undefined;
        this.compcase.timeOfInjury = data.timeOfInjury
          ? this.dayjs(data.timeOfInjury).valueOf()
          : undefined;
        this.compcase.dateOfInjuryStr = data.dateOfInjuryStr;
        this.compcase.timeOfInjuryStr = data.timeOfInjuryStr;
        this.compcase.symptons = data.symptons;
        // If concussion happens
        if (data.symptons && data.concussion) {
          this.compcase.concussion.clinicalFeatures = data.concussion.clinicalFeatures;
          this.compcase.concussion.lossOfConsciousness = data.concussion.lossOfConsciousness;

          this.compcase.concussion.protectiveAction = data.concussion.protectiveAction;

          this.compcase.concussion.impact = data.concussion.impact;

          this.compcase.concussion.balanceDisturbance = data.concussion.balanceDisturbance;

          this.compcase.concussion.dazedOrBlank = data.concussion.dazedOrBlank;

          this.compcase.concussion.unusualBehaviour = data.concussion.unusualBehaviour;

          this.compcase.concussion.confusion = data.concussion.confusion;

          this.compcase.concussion.memoryImpairment = data.concussion.memoryImpairment;

          this.compcase.concussion.playerReports = data.concussion.playerReports;

          if (data.symptomRecord) {
            this.compcase.symptomRecord.playerSelfState = data.symptomRecord.playerSelfState
              ? data.symptomRecord.playerSelfState
              : "No different";
            this.compcase.symptomRecord.headache = data.symptomRecord.headache
              ? data.symptomRecord.headache
              : "None";
            this.compcase.symptomRecord.pressureInHead = data.symptomRecord.pressureInHead
              ? data.symptomRecord.pressureInHead
              : "None";
            this.compcase.symptomRecord.neckPain = data.symptomRecord.neckPain
              ? data.symptomRecord.neckPain
              : "None";
            this.compcase.symptomRecord.nauseaOrVomit = data.symptomRecord.nauseaOrVomit
              ? data.symptomRecord.nauseaOrVomit
              : "None";
            this.compcase.symptomRecord.dizzy = data.symptomRecord.dizzy
              ? data.symptomRecord.dizzy
              : "None";
            this.compcase.symptomRecord.blurVision = data.symptomRecord.blurVision
              ? data.symptomRecord.blurVision
              : "None";
            this.compcase.symptomRecord.balanceProblem = data.symptomRecord.balanceProblem
              ? data.symptomRecord.balanceProblem
              : "None";
            this.compcase.symptomRecord.lightSensitivity = data.symptomRecord.lightSensitivity
              ? data.symptomRecord.lightSensitivity
              : "None";
            this.compcase.symptomRecord.noiseSensitivity = data.symptomRecord.noiseSensitivity
              ? data.symptomRecord.noiseSensitivity
              : "None";
            this.compcase.symptomRecord.slowedDown = data.symptomRecord.slowedDown
              ? data.symptomRecord.slowedDown
              : "None";
            this.compcase.symptomRecord.inAFog = data.symptomRecord.inAFog
              ? data.symptomRecord.inAFog
              : "None";
            this.compcase.symptomRecord.notFeelRight = data.symptomRecord.notFeelRight
              ? data.symptomRecord.notFeelRight
              : "None";
            this.compcase.symptomRecord.difficultyInConcentrating = data.symptomRecord
              .difficultyInConcentrating
              ? data.symptomRecord.difficultyInConcentrating
              : "None";
            this.compcase.symptomRecord.difficultyRemembering = data.symptomRecord
              .difficultyRemembering
              ? data.symptomRecord.difficultyRemembering
              : "None";
            this.compcase.symptomRecord.fatigued = data.symptomRecord.fatigued
              ? data.symptomRecord.fatigued
              : "None";
            this.compcase.symptomRecord.confused = data.symptomRecord.confused
              ? data.symptomRecord.confused
              : "None";
            this.compcase.symptomRecord.drowsy = data.symptomRecord.drowsy
              ? data.symptomRecord.drowsy
              : "None";
            this.compcase.symptomRecord.emotional = data.symptomRecord.emotional
              ? data.symptomRecord.emotional
              : "None";
            this.compcase.symptomRecord.irritable = data.symptomRecord.irritable
              ? data.symptomRecord.irritable
              : "None";
            this.compcase.symptomRecord.sad = data.symptomRecord.sad
              ? data.symptomRecord.sad
              : "None";
            this.compcase.symptomRecord.nervousOrAnxious = data.symptomRecord.nervousOrAnxious
              ? data.symptomRecord.nervousOrAnxious
              : "None";
          }
        }

        this.compcase.howPlayerInjured = data.howPlayerInjured;
        this.compcase.howPlayerInjuredOther = data.howPlayerInjuredOther
          ? data.howPlayerInjuredOther
          : "";
        this.compcase.treatPlayer = data.treatPlayer;

        this.compcase.playerReferredTo = data.playerReferredTo ? data.playerReferredTo : undefined;
        this.compcase.playerReferredToOther = data.playerReferredToOther
          ? data.playerReferredToOther
          : "";
        this.compcase.immediateCare = data.immediateCare ? data.immediateCare : undefined;
        this.compcase.immediateCareOther = data.immediateCareOther ? data.immediateCareOther : "";
        this.compcase.firstResponderName = data.firstResponderName ? data.firstResponderName : "";
        this.compcase.firstResponderRole = data.firstResponderRole
          ? data.firstResponderRole
          : undefined;
        this.compcase.natureOfInjury = data.natureOfInjury ? data.natureOfInjury : [];
        this.compcase.playerRemoveBy = data.playerRemoveBy ? data.playerRemoveBy : undefined;
        this.compcase.otherSignificants = data.otherSignificants ? data.otherSignificants : "";
        this.compcase.round = data.round ? data.round : undefined;

        if (this.compcase.status === "Completed") {
          this.active = 2;
        } else {
          if (type === undefined && id) {
            this.$router.push("/injury-cases");
          } else {
            this.active = 0;
          }
        }
        this.$store.commit("root/loading", false);
      } catch (e) {
        this.$store.commit("root/loading", false);
        this.$customError(e);
      }
    }
  },
  methods: {
    editInjury() {
      this.active = 1;
      this.editReportFlag = true;
      window.scrollTo(0, 0);
    },
    goToLocationStep() {
      if (this.compcase.status === "Completed") {
        this.active = this.active;

        if (this.locationStepComplete || this.editReportFlag) this.active = 0;
      } else {
        this.active = 0;
      }
    },
    goToDetailsStep() {
      if (this.locationStepComplete) {
        this.active = 1;
      } else if (this.editReportFlag && this.compcase.status === "Completed") {
        this.locationStepComplete = true;
      } else {
        this.active = this.active;
      }
    },
    goToCompleteStep() {
      this.compcase.status === "Completed" && this.active === 3
        ? (this.active = 2)
        : this.locationStepComplete && this.detailsStepComplete && this.editReportFlag === false
        ? (this.active = 2)
        : (this.active = this.active);
    },
    goToShareStep() {
      this.compcase.status === "Completed"
        ? this.completeStepComplete
          ? (this.active = 3)
          : (this.active = this.active)
        : this.locationStepComplete && this.detailsStepComplete && this.completeStepComplete
        ? (this.active = 3)
        : (this.active = this.active);
    },
    completeStep(injury, moveToNextStep, memberEmail) {
      this.compcase = injury;

      switch (this.active) {
        case 0:
          this.locationStepComplete = moveToNextStep;
          break;
        case 1:
          this.detailsStepComplete = moveToNextStep;
          this.editReportFlag = false;
          this.locationStepComplete = false;
          break;
        case 2:
          this.locationStepComplete = false;
          this.detailsStepComplete = false;
          this.completeStepComplete = moveToNextStep;
          this.memberEmail = memberEmail;
          break;
        case 3:
          this.locationStepComplete = false;
          this.detailsStepComplete = false;
          this.shareStepComplete = moveToNextStep;
          this.completeStepComplete = moveToNextStep;
          break;
      }
      if (moveToNextStep === true) {
        this.active += 1;

        window.scrollTo(0, 0);
      }
    },
    redirectTo() {
      this.$router.push({
        name: "injury-cases",
      });
    },
    reset() {
      this.active = 0;
      this.compcase = {
        type: 2,
        status: "Pending",
        isActive: true,
        scene: undefined,
        sceneOther: undefined,
        memberId: undefined,
        meta: {
          competition: {
            _id: undefined,
            name: undefined,
          },
          matchId: undefined,
          teamId: undefined,
          programId: undefined,
        },
        matches: [],
        member: {
          _id: undefined,
          name: "",
        },
        venue: {
          _id: undefined,
          name: "",
          formatted: "",
        },
        dateOfInjury: undefined,
        timeOfInjury: undefined,
        dateOfInjuryStr: "",
        timeOfInjuryStr: "",
        symptons: undefined,
        treatPlayer: undefined,
        playerReferredTo: undefined,
        playerReferredToOther: "",
        immediateCare: undefined,
        immediateCareOther: "",
        natureOfInjury: [],
        playerRemoveBy: undefined,
        otherSignificants: "",
        emails: ["", "", "", ""],
        round: undefined,
      };
    },
  },
  watch: {},
};
</script>

<style>
@media only screen and (max-width: 767px) {
  .step-btn {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .step-btn button:first-child {
    order: 2;
  }
  .step-btn button:last-child {
    order: 1;
  }
  .step-btn .el-button + .el-button {
    margin-left: 0;
    margin-bottom: 16px;
  }
  .step-btn button {
    height: 48px;
  }
  .step-btn-more_space.step-btn {
    margin-top: 144px;
  }

  .container .card {
    width: 88% !important;
  }
}
</style>
